// extracted by mini-css-extract-plugin
export default {"inner":"emoji_inner__ZgxbI","svg":"emoji_svg__4nTOM","stripes-animation-background-keyframes":"emoji_stripes-animation-background-keyframes__mlGoU"};